<!--
 * @Author: zxf
 * @Date: 2022-08-08 16:50:37
 * @LastEditors: DQL
 * @LastEditTime: 2022-09-11 21:33:54
 * @Description: 岗位人员组件
-->
<template>
  <el-select
    v-bind="$attrs"
    v-on="$listeners"
  >
    <el-option
      v-for="item in userList"
      :key="item.capacityCode"
      :label="showDept ? `${item.capacityName}（${item.deptName}）` : item.capacityName"
      :value="item.capacityCode"
    />
  </el-select>
</template>

<script>
export default {
  name: 'SelectXmUser',
  props: {
    // 角色类型：项目管理员projectsManage、消防工程师FireEngineer、维保员WBRY、检测员JCRY、评估人员PGRY、审核人JCXMSHR
    roleCode: {
      type: String,
      required: true
    },
    showDept: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      userList: []
    };
  },
  methods: {
    init () {
      const currentUser = this.$HMStoreService.getUserinfo();
      const params = {
        deptCode: currentUser ? currentUser.dept.deptCode : this.deptCode
      };
      this.$axios.get(`${this.$config.commontCtx}/roleCapacity/role/${this.roleCode}/capacities`, { params: params })
        .then(rsp => {
          this.userList = rsp.data;
        })
        .catch(err => {
          console.error(`获取岗位信息失败：${this.roleCode}}`, err);
        });
    }
  },
  created () {
    this.init();
  }
};
</script>
